import { type ErrorBoundaryProps, ErrorState } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

export default function KnowledgeError({ error, reset }: ErrorBoundaryProps) {
  const t = useT()
  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('Failed to load knowledge')}
      description={t('Something went wrong while loading your knowledge bases. Please try again.')}
      loggerName='KnowledgeError'
    />
  )
}
